import { FrameInput } from '@vfit/shared/atoms';
import { forwardRef } from 'react';
import { useFrameEditorialInput } from './frameEditorialInput.hook';
import { IFrameEditorialInput } from './frameEditorialInput.models';
import * as S from './frameEditorialInput.style';

export const FrameEditorialInput = forwardRef<HTMLInputElement, IFrameEditorialInput>(
  ({ children, description, title, variant = 'primary', ...rest }, ref) => {
    const { pDescription } = useFrameEditorialInput({ description });

    return (
      <FrameInput {...rest} ref={ref} variant={variant}>
        <S.Wrapper>
          {title && <S.Title>{title}</S.Title>}
          {pDescription && (
            <S.Description
              dangerouslySetInnerHTML={{
                __html: pDescription,
              }}
            />
          )}
          {children}
        </S.Wrapper>
      </FrameInput>
    );
  }
);

